module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table_rows_per_page":"Rows per page","pagination_total_rows":"rows","pagination_of_total":"of total"},"vi":{"table_rows_per_page":"Số đơn hiển thị","pagination_total_rows":"đơn","pagination_of_total":"trên tổng đơn"}}')
  delete Component.options._Ctor
}
